import { render, staticRenderFns } from "./shopper.vue?vue&type=template&id=8d1f552c&scoped=true"
import script from "./shopper.vue?vue&type=script&lang=js"
export * from "./shopper.vue?vue&type=script&lang=js"
import style0 from "./shopper.vue?vue&type=style&index=0&id=8d1f552c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1f552c",
  null
  
)

export default component.exports